import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { userdata } from './types';
import { updateUseractions as actions } from './index';
import { authenticatedPut } from 'remote/api';

export function* UpdateInfo(action: PayloadAction<userdata>) {
  // yield takeLatest(actions.someAction.type, doSomething);
  try {
    const response = yield call(
      authenticatedPut,
      `${process.env.REACT_APP_API_URL}/profile`,
      action.payload,
    );

    yield put(actions.updateUserSuccess(response.data));
  } catch (error: any) {
    yield put(actions.updateUserFailure(error.message));
  }
}
export function* watchUpdateUser() {
  yield takeLatest(actions.updateUser.type, UpdateInfo);
}
